<div id="advertisement-dialog">
    <div id="dialog-title" mat-dialog-title>
        <span id="dialog-header">Draw Signature</span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>

<mat-dialog-content>
  <div class="signature-container">
    <canvas #canvas class="signature-pad"></canvas>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn" (click)="clearSignature()">Clear</button>
  <button class="btn" (click)="saveSignature()">Save</button>
</mat-dialog-actions>